import './lib/utils/closestPolyfill';
import 'moment/locale/fr';
import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { IntlProvider } from 'react-intl';
import { AppContainer } from 'react-hot-loader';
import environmentCheck from './lib/environment-check';
import Layout from './ticket-listings/components/social-share/layout';
import store from './ticket-listings/stores/redux-store';
import MessagesStore from './stores/messagesStore';
import initBugsnag from 'webapp-common-ui/src/components/init-bugsnag';
import backForwardCacheInvalidator from './utils/backForwardCacheInvalidator';
import { initMoment } from 'webapp-common-ui/src/utils';

import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { loadAverta, averta } from 'src/utils/fonts';
import { evaluateTheme } from 'webapp-common-ui/src/components/theme-provider/reducer';
import { TM, LN } from 'webapp-common-ui/src/components/theme-provider/themes';

initBugsnag();

const options = {
  siteContext: window.siteContext,
};

const theme = options.siteContext.domainToken === 'ln' ? LN : TM;

const GlobalStyle = createGlobalStyle`
  ${options.siteContext.domainToken !== 'ln' && `
    ${loadAverta()};

    body {
      font-family: ${averta};
    }
  `}
`;

const themeStore = evaluateTheme({
  ...theme,
  'base-border-radius': '2px',
  'legend-min-width': '180px',
});

const app = document.getElementById('socialShare');

const socialShare = (
  <IntlProvider locale="en" messages={MessagesStore.get()}>
    <Provider store={store}>
      <ThemeProvider theme={themeStore}>
        <React.Fragment>
          <Layout options={options} />
          <GlobalStyle />
        </React.Fragment>
      </ThemeProvider>
    </Provider>
  </IntlProvider>
);

if (process.env.NODE_ENV !== 'production') {
  if (app) {
    render(
      <AppContainer>
        {socialShare}
      </AppContainer>,
      app,
    );
  }

  if (module.hot) {
    module.hot.accept('./ticket-listings/components/layout', () => {
      render(
        <AppContainer>
          {socialShare}
        </AppContainer>,
        app,
      );
    });
  }
} else if (app) {
  render(
    socialShare,
    app,
  );
}

initMoment(options.siteContext.language);
environmentCheck(window);
backForwardCacheInvalidator(window, navigator);
